import { call, put, takeLatest, all } from "redux-saga/effects";
import {
  fetchTeamLead,
  addCompanyApi,
  addJobApi,
  deleteJobOrCompany,
  fetchCompanyByUiid,
  fetchProspects,
  fetchCompanies,
  fetchTodaysCompanies,
  updateJobApi,
  fetchCompanyJobCountsApi,
  fetchRaSettingsApi,
  saveRaSettingsApi,
  updateRaSettingsApi,
  updateCompanystatusApi,
  fetchProspectsApi,
  fetchDailyproduction,
  fetchAllteamApi,
  mergeCompanyApi,
  MyLeadsCardCount,
  fetchTeamSummaryApi
} from "./leadsApi";

import {
  // getTeamLeadStart,
  // getTeamLeadSuccess,
  // getTeamLeadFailure,

  getTodaysTeamLeadStart,
  getTodaysTeamLeadSuccess,
  getTodaysTeamLeadFailure,
  getYesterdaysTeamLeadStart,
  getYesterdaysTeamLeadSuccess,
  getYesterdaysTeamLeadFailure,
  addCompanyFailure,
  addCompanyStart,
  addCompanySuccess,
  addJobFailure,
  addJobStart,
  addJobSuccess,
  deleteJobFailure,
  deleteJobStart,
  deleteJobSuccess,
  fetchCompanyFailure,
  fetchCompanyStart,
  fetchCompanySuccess,
  getTodaysCompaniesFailure,
  getTodaysCompaniesStart,
  getTodaysCompaniesSuccess,
  updateJobDeatilsStart,
  updateFailureSuccess,
  updateJobDeatilsSucess,
  searchStart,
  searchSuccess,
  searchFailure,
  //team count
  getTodaysCompanyJobCountsStart,
  getTodaysCompanyJobCountsSuccess,
  getTodaysCompanyJobCountsFailure,
  getYesterdaysCompanyJobCountsStart,
  getYesterdaysCompanyJobCountsSuccess,
  getYesterdaysCompanyJobCountsFailure,

  bulkUploadStart,
  bulkUploadSuccess,
  bulkUploadFailure,
  clearBulkUpload,
  // RA Settings
  getRaSettingsStart,
  getRaSettingsSuccess,
  getRaSettingsFailure,
  clearRaSettings,
  saveRaSettingsStart,
  saveRaSettingsSuccess,
  saveRaSettingsFailure,

  // update Ra Settings
  updateRaSettingsStart,
  updateRaSettingsSuccess,
  updateRaSettingsFailure,

  updateCompanyStatusStart,
  updateCompanyStatusFailure,
  updateCompanyStatusSuccess,

  getProspectsStart,
  getProspectsSuccess,
  getProspectsFailure,
  //daily production
  getDailyProductionStart,
  getDailyProductionSuccess,
  getDailyProductionFailure,
  // all leads
  fetchAllLeadsStart,
  fetchAllLeadsSuccess,
  fetchAllLeadsFailure,
  fetchTeamLeadsSuccess,
  fetchTeamLeadsFailure,
  clearAllLeads,
  clearTeamLeads,
  fetchTeamLeadsStart,
  getTeamProspectsStart,
  getTeamProspectsSuccess,
  getTeamProspectsFailure,
   fetchMyTeamSummaryStart,
  myTeamSummarySuccess,
  myTeamSummaryFailure,
   fetchTodayTeamSummaryStart,
  todayTeamSummarySuccess,
  todayTeamSummaryFailure,
  fetchYesterdayTeamSummaryStart,
  yesterdayTeamSummarySuccess,
  yesterdayTeamSummaryFailure,
  fetchTotalMyTeamSummaryStart,
    totalmyTeamSummarySuccess,
    totalmyTeamSummaryFailure,
    getTeamProspectsCountSuccess,
    getTeamProspectsCountStart
} from "./leadsSlice";


import { showToast } from "../../../components";



function* fetchTodaysTeamLeadSaga(action) {
  try {
    const response = yield call(fetchTeamLead, action.payload);
    if (response?.success) {
      yield put(getTodaysTeamLeadSuccess({
        data: response?.data?.data?.updatedResponse || [],
        total: response?.data?.data?.totalCount || 0,
      }));
    }
  } catch (error) {
    yield put(getTodaysTeamLeadFailure(error.message));
  }
}


function* fetchYesterdaysTeamLeadSaga(action) {
  try {

    const response = yield call(fetchTeamLead, action.payload);
    yield put(getYesterdaysTeamLeadSuccess({
      data: response?.data?.data?.updatedResponse || [],
      total: response?.data?.data?.totalCount || 0,
    }));
  } catch (error) {
    yield put(getYesterdaysTeamLeadFailure(error.message));
  }
}

function* fetchCompanyWorker(action) {
  try {
    const { uiid, ref } = action.payload;
    const response = yield call(fetchCompanyByUiid, { uiid, ref });
    if (response?.data) {
      yield put(fetchCompanySuccess(response.data.data));
    } else {
      yield put(fetchCompanyFailure("Company not found"));
    }
  } catch (error) {
    yield put(fetchCompanyFailure(error.message));
  }
}

function* addCompanyWorker(action) {
  try {
    const { name, addedBy, website, domain } = action.payload;
    const response = yield call(addCompanyApi, { name, addedBy, website, domain });
    if (response?.data) {
      const newCompany = response.data.data;
      yield put(addCompanySuccess(newCompany));
    } else {
      yield put(addCompanyFailure("Failed to add company"));
    }
  } catch (error) {
    yield put(addCompanyFailure(error.message));
  }
}

function* addJobWorker({ payload }) {
  try {
    const { onSuccess, ...ret } = payload;
    const response = yield call(addJobApi, ret);
    if (response.success) {
      onSuccess(response)
      showToast("Job and Prospects updated successfully", "success", 2000);
      const waitingPeriodNotCompleted = response?.data?.data?.postActionResult[0]?.result?.waitingPeriodNotCompleted?.map(p => p.email).join(", ");;
      const prospectBlockedUiids = response?.data?.data?.postActionResult[0]?.result?.prospectBlockedUiids?.map(p => p.email).join(", ");;
      if (waitingPeriodNotCompleted) {
        showToast(`Duplicate Emails: ${waitingPeriodNotCompleted}`, "error");
      }
      if (prospectBlockedUiids) {
        showToast(`These Emails blocked or invalid: ${prospectBlockedUiids}`, "error");
      }

      yield put(addJobSuccess());
    } else {
      showToast(response?.field || response?.error || "Failed to add job", "error", 2000);
      yield put(addJobSuccess());
    }
  } catch (error) {
    showToast("error.message", "error", 2000);
    yield put(addJobFailure(error.message));
  }
}

function* deleteJobWorker(action) {
  try {
    const { company, jobUiid, onSuccess } = action.payload;
    const response = yield call(deleteJobOrCompany, { company, jobUiid });

    if (response?.message) {
      yield put(deleteJobSuccess({ company, jobUiid }));
      showToast(response.message, "success", 2000);
    } else {
      yield put(deleteJobFailure("Failed to delete job"));
    }

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    yield put(deleteJobFailure(error.message));
  }
}

function* handleSearch(action) {
  try {
    const input = action.payload;
    let response;
    let type;
    let results = [];

    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
    const isDomain = /\.(com|in|org|net)$/i.test(input);

    if (isEmail) {
      type = "prospect";
      response = yield call(fetchProspects, {
        filters: { "email.primary": { type: "SEARCH", value: input } },
        limit: 10,
        page: 1,
      });
      results = response.data?.data || [];

    } else if (isDomain) {
      type = "domain";
      response = yield call(fetchCompanies, {
        filters: { domain: { type: "SEARCH", value: input } },
        limit: 10,
        page: 1,
        ret: "uiid name"
      });
      results = response.data.data || [];
    } else {
      type = "company";
      response = yield call(fetchCompanies, {
        filters: { name: { type: "SEARCH", value: input } },
        limit: 10,
        page: 1,
        postActions: ["GoogleSearch"],
        ret: "uiid name"
      });

      if (response.data?.data?.length > 0) {
        results = response.data.data.map((company) => ({
          ...company
        }));
      } else {
        const googleResults = response.data?.field?.find(
          (f) => f.action === "GoogleSearch"
        )?.result?.response;

        results = Array.isArray(googleResults)
          ? googleResults.map((name) => ({ name }))
          : [];
      }
    }

    yield put(searchSuccess({ data: results, type }));
  } catch (error) {
    yield put(searchFailure(error.message || "Search failed"));
  }
}
function* fetchTodaysCompaniesSaga(action) {
  try {
    const companies = yield call(fetchTodaysCompanies, action.payload);
    if (companies) {
      yield put(getTodaysCompaniesSuccess(companies));
    } else {
      yield put(getTodaysCompaniesSuccess({}));
    }
  } catch (error) {
    console.log("error", error);
    yield put(getTodaysCompaniesFailure(error.message));
  }
}
function* updateJobDeatilsWorkerSaga(action) {
  try {
    const { onSuccess, ...rest } = action.payload;
    const response = yield call(updateJobApi, rest);

    if (response.success) {
      yield put(updateJobDeatilsSucess());
      showToast("Job updated successfully", "success", 2000);

      const duplicateEmails = response?.data?.data?.postActionResult[0]?.result?.duplicateProspects?.map(p => p.email.email).join(", ");
      if (duplicateEmails) {
        showToast(`Duplicate Emails: ${duplicateEmails}`, "error");
      }
      const waitingPeriodNotCompleted = response?.data?.data?.postActionResult[0]?.result?.waitingPeriodNotCompleted?.map(p => p.email).join(", ");;
      const prospectBlockedUiids = response?.data?.data?.postActionResult[0]?.result?.prospectBlockedUiids?.map(p => p.email).join(", ");;
      if (waitingPeriodNotCompleted) {
        showToast(`Duplicate Emails: ${waitingPeriodNotCompleted}`, "error");
      }
      if (prospectBlockedUiids) {
        showToast(`These Emails blocked or invalid: ${prospectBlockedUiids}`, "error");
      }
      if (onSuccess) onSuccess()
    } else {
      showToast(response.error, "error", 2000);
      yield put(updateFailureSuccess("Failed to update job"));
    }
  } catch (error) {
    showToast(error, "error", 2000);
    yield put(updateFailureSuccess(error.message));
  }
}
// Team count sagas

function* fetchTodaysCompanyJobCountsSaga(action) {
  try {
    const { dateType, ...rest } = action.payload

    // const response = yield call(fetchCompanyJobCountsApi, rest);
    const response = yield call(MyLeadsCardCount, rest);

    // if (response.success) {
      if (dateType == "today") {

        yield put(getTodaysCompanyJobCountsSuccess({
          data: response?.data?.data || [],
          total: response?.data?.total || 0,
        }));
      } else {
        yield put(getYesterdaysCompanyJobCountsSuccess({
          data: response?.data?.data || [],
          total: response?.data?.total || 0,
        }));
      }
    // }
  } catch (error) {
    yield put(getTodaysCompanyJobCountsFailure(error.message));
    showToast(error.message || "Failed to fetch today's company job counts", "error", 2000);
  }
}



function* fetchYesterdaysCompanyJobCountsSaga(action) {
  try {
    const response = yield call(fetchCompanyJobCountsApi, action.payload);


    yield put(getYesterdaysCompanyJobCountsSuccess({
      data: response?.data?.data || [],
      total: response?.data?.total || 0,
    }));
  } catch (error) {
    yield put(getYesterdaysCompanyJobCountsFailure(error.message));
    showToast(error.message || "Failed to fetch yesterday's company job counts", "error", 2000);
  }
}


function* bulkUploadWorker(action) {
  try {
    const { onSuccess, ...rest } = action.payload;

    // Call your API
    const response = yield call(bulkUploadApi, rest);

    if (response.success) {
      yield put(
        bulkUploadSuccess({
          data: response?.data?.data || [],
          total: response?.data?.total || (response?.data?.data ? response.data.data.length : 0),
        })
      );

      showToast("Bulk upload successful", "success", 2000);

      if (onSuccess) onSuccess();
    } else {
      yield put(bulkUploadFailure(response.message || "Bulk upload failed"));
      showToast(response.message || "Bulk upload failed", "error", 2000);
    }
  } catch (error) {
    yield put(bulkUploadFailure(error.message));
    showToast(error.message || "Bulk upload failed", "error", 2000);
  }
}


function* fetchRaSettingsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchRaSettingsApi, params);

    const raSettingsData = response?.data?.data || [];


    yield put(getRaSettingsSuccess({
      data: raSettingsData,
      total: response?.data?.total || raSettingsData.length || 0,
    }));

    // if (onSuccess) onSuccess(raSettingsData[0]?.raSetting || null);


    // if (raSettingsData.length > 0) {
    //   showToast("RA Settings fetched successfully", "success", 2000);
    // }


  } catch (error) {
    yield put(getRaSettingsFailure(error.message));
    showToast(error.message || "Failed to fetch settings", "error", 2000);
  }
}


function* updateRaSettingsWorker(action) {
  try {
    const { uiid, payload,onSuccess } = action.payload;
    const response = yield call(updateRaSettingsApi, { uiid, payload });

    const updatedDoc = response?.data?.data?.doc; // full doc
    console.log("Updated Doc:", updatedDoc);

    if (updatedDoc?.raSetting) {
      yield put(
        updateRaSettingsSuccess({
          uiid, // tell reducer which one to update
          data: updatedDoc.raSetting,
        })
      );
      showToast("Settings updated successfully", "success", 2000);
      if (onSuccess) {
        yield call(onSuccess, updatedDoc);
      }
    } else {
      yield put(updateRaSettingsFailure("Failed to update settings"));
      showToast("Failed to update settings", "error", 2000);
    }
  } catch (error) {
    console.error("Update Error:", error);
    yield put(updateRaSettingsFailure(error.message));
    showToast(error.message || "Failed to update settings", "error", 2000);
  }
}

function* saveRaSettingsWorker(action) {
  try {
    const response = yield call(saveRaSettingsApi, action.payload);
    const savedDoc = response?.data?.data; // { uiid: 55, ... }

    if (savedDoc?.uiid) {
      yield put(saveRaSettingsSuccess({ data: savedDoc, total: 1 }));
      showToast("Settings saved successfully", "success", 2000);

      // Trigger onSuccess callback if provided
      if (action.payload?.onSuccess) {
        action.payload.onSuccess(savedDoc);
      }
    } else {
      yield put(saveRaSettingsFailure("Failed to save settings"));
      showToast("Failed to save settings", "error", 2000);
    }
  } catch (error) {
    yield put(saveRaSettingsFailure(error.message));
    showToast(error.message || "Failed to save settings", "error", 2000);
  }
}


function* updateCompanyStatusWorker(action) {
  try {
    const { uiid, payload, onSuccess } = action.payload;
    const response = yield call(updateCompanystatusApi, { uiid, payload });

    if (response?.data?.data) {
      yield put(updateCompanyStatusSuccess(response.data.data));
      showToast("Company status updated successfully", "success", 2000);
      if (onSuccess) onSuccess(response.data.data);
    } else {
      yield put(updateCompanyStatusFailure("Failed to update company status"));
      showToast("Failed to update company status", "error", 2000);
    }
  } catch (error) {
    yield put(updateCompanyStatusFailure(error.message));
    showToast(error.message || "Failed to update company status", "error", 2000);
  }
}
function* fetchProspectsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};

    const response = yield call(fetchProspectsApi, params);

    const prospectsData = response?.data?.data || [];
    yield put(getProspectsSuccess({
      data: prospectsData,
      total: response?.data?.total || prospectsData.length || 0,
    }));

    if (onSuccess) onSuccess(prospectsData);

  } catch (error) {
    yield put(getProspectsFailure(error.message));
    showToast(error.message || "Failed to fetch prospects", "error", 2000);
  }
}

function* fetchTeamProspectsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};

    const response = yield call(fetchProspectsApi, params);

    const prospectsData = response?.data?.data || [];
    yield put(getTeamProspectsSuccess(prospectsData));

    if (onSuccess) onSuccess(prospectsData);

  } catch (error) {
    yield put(getTeamProspectsFailure(error.message));
    showToast(error.message || "Failed to fetch prospects", "error", 2000);
  }
}
function* fetchTeamProspectsCountWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};
    const response = yield call(fetchProspectsApi, params);
    const prospectsData = response?.data?.data || [];
    yield put(getTeamProspectsCountSuccess(prospectsData));

    if (onSuccess) onSuccess(prospectsData);
  } catch (error) {
    yield put(getTeamProspectsFailure(error.message));
    showToast(error.message || "Failed to fetch prospects", "error", 2000);
  }
}


function* handleGetDailyProduction(action) {
  try {
    const response = yield call(fetchDailyproduction, action.payload);
    yield put(getDailyProductionSuccess(response));
  } catch (error) {
    yield put(getDailyProductionFailure(error.message));
  }
}

function* fetchAllLeadsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};
    const response = yield call(fetchAllteamApi, params);

    const allLeadsData = response?.data?.data || [];

    yield put(
      fetchAllLeadsSuccess({
        data: allLeadsData,
        total: response?.data?.total || allLeadsData.length || 0,
      })
    );

    // Optional callback
    if (onSuccess) onSuccess(allLeadsData);

    // Optional toast
    // if (allLeadsData.length > 0) {
    //   showToast("All leads fetched successfully", "success", 2000);
    // }

  } catch (error) {
    yield put(fetchAllLeadsFailure(error.message));
    showToast(error.message || "Failed to fetch all leads", "error", 2000);
  }
}

function* mergeCompanyJobs(action) {
  try {
    const { mergeCompanyId, updatedData, deleteCompanyIds } = action.payload;

    const requestBody = {
      coll: "Company",
      payload: {
        mergeCompanyId,
        updatedData,
        deleteCompanyIds,
      },
    };

    const response = yield call(mergeCompanyApi, requestBody);

    if (response?.data) {
      yield put(mergeCompanySuccess(response.data.data));
    } else {
      yield put(mergeCompanyFailure("Failed to merge company"));
    }
  } catch (error) {
    yield put(mergeCompanyFailure(error?.message ?? "Something went wrong"));
  }
}

export default fetchAllLeadsWorker;

function* fetchTeamLeadsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};
    const response = yield call(fetchAllteamApi, params);

    const allLeadsData = response?.data?.data || [];

    yield put(
      fetchTeamLeadsSuccess({
        data: allLeadsData,
        total: response?.data?.total || allLeadsData.length || 0,
      })
    );

    // Optional callback
    if (onSuccess) onSuccess(allLeadsData);

    // Optional toast
    // if (allLeadsData.length > 0) {
    //   showToast("All leads fetched successfully", "success", 2000);
    // }

  } catch (error) {
    yield put(fetchTeamLeadsFailure(error.message));
    showToast(error.message || "Failed to fetch all leads", "error", 2000);
  }
}
//myteam summary
function* handleMyTeamSummaryWorker(action) {
  try {
    const response = yield call(fetchTeamSummaryApi, action.payload);
     const data = response?.data?.data || []
     yield put(myTeamSummarySuccess({ data: data }));
  } catch (error) {
    yield put(myTeamSummaryFailure(error.message));
  }
}

function* handleTodayMyTeamSummaryWorker(action) {
  try {
    const response = yield call(fetchTeamSummaryApi, action.payload);
     const data = response?.data?.data || []
     yield put(todayTeamSummarySuccess({ data: data }));
  } catch (error) {
    yield put(todayTeamSummaryFailure(error.message));
  }
}

function* handleYesterdayMyTeamSummaryWorker(action) {
  try {
    const response = yield call(fetchTeamSummaryApi, action.payload);
     const data = response?.data?.data || []
     yield put(yesterdayTeamSummarySuccess({ data: data }));
  } catch (error) {
    yield put(yesterdayTeamSummaryFailure(error.message));
  }
}

function* handleTotalMyTeamSummaryWorker(action) {
  try {
    const response = yield call(fetchTeamSummaryApi, action.payload);
     const data = response?.data?.data || []
     yield put(totalmyTeamSummarySuccess({ data: data }));
  } catch (error) {
    yield put(totalmyTeamSummaryFailure(error.message));
  }
}


export function* watchFetchLeadsSaga() {
  // yield takeLatest(getTeamLeadStart.type, fetchTeamLeadSaga);
  yield takeLatest(getTodaysTeamLeadStart.type, fetchTodaysTeamLeadSaga);
  yield takeLatest(getYesterdaysTeamLeadStart.type, fetchYesterdaysTeamLeadSaga);
  yield takeLatest(fetchCompanyStart.type, fetchCompanyWorker);
  yield takeLatest(addCompanyStart.type, addCompanyWorker);
  yield takeLatest(addJobStart.type, addJobWorker);
  yield takeLatest(deleteJobStart.type, deleteJobWorker);
  yield takeLatest(searchStart.type, handleSearch);
  yield takeLatest(getTodaysCompaniesStart.type, fetchTodaysCompaniesSaga);
  yield takeLatest(updateJobDeatilsStart.type, updateJobDeatilsWorkerSaga);
  //team count
  yield takeLatest(getTodaysCompanyJobCountsStart.type, fetchTodaysCompanyJobCountsSaga);
  yield takeLatest(getYesterdaysCompanyJobCountsStart.type, fetchYesterdaysCompanyJobCountsSaga);
  yield takeLatest(bulkUploadStart.type, bulkUploadWorker);
  yield takeLatest(getRaSettingsStart.type, fetchRaSettingsWorker);
  yield takeLatest(saveRaSettingsStart.type, saveRaSettingsWorker);
  yield takeLatest(updateRaSettingsStart.type, updateRaSettingsWorker);
  yield takeLatest(updateCompanyStatusStart.type, updateCompanyStatusWorker);
  yield takeLatest(getProspectsStart.type, fetchProspectsWorker);
  yield takeLatest(getDailyProductionStart.type, handleGetDailyProduction);
  // all leads
  yield takeLatest(fetchAllLeadsStart.type, fetchAllLeadsWorker);
  yield takeLatest(addCompanyStart.type, mergeCompanyJobs);
  yield takeLatest(fetchTeamLeadsStart.type, fetchTeamLeadsWorker);
  yield takeLatest(getTeamProspectsStart.type, fetchTeamProspectsWorker);
  yield takeLatest(getTeamProspectsCountStart.type, fetchTeamProspectsCountWorker);
  //my team summary
  yield takeLatest(fetchMyTeamSummaryStart.type, handleMyTeamSummaryWorker);
  yield takeLatest(fetchTodayTeamSummaryStart.type, handleTodayMyTeamSummaryWorker);
  yield takeLatest(fetchYesterdayTeamSummaryStart.type, handleYesterdayMyTeamSummaryWorker);
   yield takeLatest(fetchTotalMyTeamSummaryStart.type, handleTotalMyTeamSummaryWorker);
}


